type ClassValue = string | number | false | null | undefined;

const classlist = (...values: ClassValue[]): string =>
	values
		.filter((v): v is string => typeof v === 'string' && v.length > 0)
		.join(' ');

export type { ClassValue };
export { classlist };
